$(document).ready(function () {

    $(document).on("click", ".langswitch .LangSection #LangSwitchButton", function () {
        GenerateLocalLoading($("body"), "show");

        var countryCode = $(".LangSection #CountryList").val();
        var LangID = $(".LangSection #LangList").val();

        if (countryCode == null || countryCode == undefined || countryCode == "") {
            SwalGenerate("error", getStandartMessages("LutfenUlkeSeçin"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading($("body"), "hide");
        }
        else if (LangID == null || LangID == undefined || LangID == "") {
            SwalGenerate("error", getStandartMessages("LutfenBirDilSecin"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading($("body"), "hide");
        }
        else {
            $.ajax({
                type: 'POST',
                url: "/LangSwitch/SetSelectedCountry?CountryCode=" + countryCode,
                cache: false,
                success: function (dt) {

                    if (dt == "False") {
                        GenerateLocalLoading($("body"), "hide");
                        SwalGenerate("error", errorMsg, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                    }
                    else {
                        //changeSiteLanguage(LangID, "");

                        $.ajax({
                            type: 'get',
                            url: '/Home/ChangePageLang',
                            data: "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + LangID + "&Cats=0",
                            success: function (dt) {
                                window.parent.location.href = dt;
                            }
                        });
                    }
                },
                error: function (dt) {
                    GenerateLocalLoading($("body"), "hide");
                    SwalGenerate("error", errorMsg, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }
            });
        }

    });

});